import { Component, OnInit } from '@angular/core';
import {ModalService} from '../../shared/services/modal.service';
import {AdminService} from '../../shared/services/admin.service';
import {empty} from '../../functions';
import {Subject} from 'rxjs';
import {ModalAdminEducationLevelComponent} from './modal-admin-education-level/modal-admin-education-level.component';
import {ModalAdminAreaofinterestComponent} from '../admin-fieldofinterest/modal-admin-areaofinterest/modal-admin-areaofinterest.component';
import {catchError} from 'rxjs/operators';
import {alertMessages, AlertService} from '../../shared/services/alert.service';
import {educationSchoolTypes} from '../../shared/services/education.service';

@Component({
    selector: 'app-admin-education-levels',
    templateUrl: './admin-education-levels.component.html',
    styleUrls: ['./admin-education-levels.component.scss'],
    standalone: false
})
export class AdminEducationLevelsComponent implements OnInit {

  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: 'Level',
        name: 'level',
        type: 'text'
      },
      {
        header_name: 'Region',
        name: 'regions',
        type: 'array'
      },
      {
        header_name: 'Name',
        name: 'name',
        type: 'text'
      },
      {
        header_name: 'School type',
        name: 'schoolType',
        type: 'text'
      },
      {
        header_name: 'Profiles',
        name: 'educationProfiles',
        field: 'name',
        type: 'array'
      }
    ],
    endpoint: 'educationlevel',
    data: <any> [],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject()

  };

  public view = {
    data: <any> []
  }

  constructor(public modal: ModalService, public adminService: AdminService, private alertService: AlertService) { }

  ngOnInit(): void {


  }


  /**
   * Add a new education level
   *
   * Uses a modal
   */
  addEducationLevel() {

    const modalOptions = {
      backdrop: 'static',
      size: 'xl'
    };

    const data = {
      entity : {
        name: '',
        level: 0,
        schoolType: educationSchoolTypes.Middelbaar,
        educationProfiles: [],
        phases: []
      }
    };

    this.modal.Modal(ModalAdminEducationLevelComponent, '','', data, [], modalOptions).then( (result) => {

      if (result === true) {
        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });

  }

  /**
   * Update education level
   *
   * @param $data
   */
  updateEducationLevel($data:any) {

    const modalOptions = {
      backdrop: 'static',
      size: 'xl'
    };

    const data = {
      entity: $data
    };

    this.modal.Modal(ModalAdminEducationLevelComponent, '', '', data, [], modalOptions).then( (result) => {

      if (result === true) {
        this.configTable.reloadListener.next(true);
      }

    }).catch( (error) => {

    });


  }

  /**
   * Delete education level
   *
   * @param $id
   */
  deleteEducationLevel($id: string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then( (confirm) => {
      if (confirm === true) {

        this.adminService.apiDeleteEducationLevel($id).pipe(catchError(this.adminService.handleError('apiDeleteEducationLevel', false))).subscribe( (result) => {

          if (result !== false) {
            this.alertService.success(alertMessages.successDataRemoved);
            this.configTable.reloadListener.next(true);
          }

        });

      }
    }).catch( (error) => {

    });

  }

  /**
   * Event button handler
   *
   * Handles output event of table when user triggers button
   *
   * @param $event
   */
  handleButtonEvent($event:any) {

    if (!empty($event['event'])) {

      switch ($event['event']) {

        case 'edit':
          this.updateEducationLevel($event['data']);
          break;

        case 'delete':
          this.deleteEducationLevel($event['data']['id']);
          break;
      }
    }

  }

}
